import React from 'react';
import { Redirect } from '../../../../Router';
import { routes } from '../../routes';

const RedirectToHome: React.FC = () => <Redirect to={routes.home.route} />;

export default RedirectToHome;
